import React, { useState, useEffect } from 'react';
import CourseContent from "./CourseContent";
import { AppBar, Toolbar, InputBase, makeStyles } from '@material-ui/core';

import { CircularProgress, Grid, Icon } from '@mui/material';
import {
    Typography,
    Box,
    Card,
    CardContent,
    CardMedia,
    LinearProgress,
    Tab,
    Tabs,
    Chip,
    ListItemIcon,
    Collapse,
} from '@mui/material';
import {
    ArrowBack,
    PlayArrow,
    Description,
    Quiz as QuizIcon,
    Star,
    ExpandMore,
    CheckCircle,
    RadioButtonUnchecked,
    Warning
} from '@mui/icons-material';
import { Container, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { List, ListItem, ListItemText, Snackbar } from '@mui/material';
import { IconButton, Tooltip, Button, } from '@mui/material';
import { PlayArrowRounded, StarHalfRounded, WarningAmberRounded, GamepadRounded } from '@mui/icons-material';
import { ChevronDown, FileText, Video, FileText as PDF } from 'lucide-react';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: 'white',
        boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.2)',
    },
    inputRoot: {
        color: 'inherit',
    },
    searchInput: {
        padding: '10px',
        borderRadius: '20px',
        backgroundColor: '#FFF',
        marginRight: theme.spacing(1),
        width: '100%',
        color: 'black'
    },
}));

const UserCourseListScreen = ({ onCourseDetailClick, course, onBack }) => {
    console.log(JSON.stringify(course));

    const classes = useStyles();
    const [expandedModule, setExpandedModule] = useState(null);
    const [activeTab, setActiveTab] = useState('content');
    const [isVideo, setIsVideo] = useState(true);
    const [isContentVideo, setIsContentVideo] = useState(true);
    const [videoModule, setVideoModule] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isRating, setIsRating] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isConsent, setIsConsent] = useState(false);
    const [isFinal, setIsFinal] = useState(course?.isFinal);
    const [quizImage, setQuizImage] = useState(require('../assets/quiz_image.jpg'));
    const [courses, setCourses] = useState([]);
    const [videoURL, setVideoURL] = useState('');
    const [currentProgress, setCurrentProgress] = useState(course.currentProgress);
    const [progressID, setProgressID] = useState(course.progressID);
    const [screen, setScreen] = useState('course');
    const [quizContent, setQuizContent] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [isBack, setIsBack] = useState(false);
    const progress = 0; // Since isCompleted is false, showing 0 progress

    // Function to show the alert
    const showErrorAlert = (message) => {
        setAlertMessage(message);
        setShowAlert(true);
        // Automatically hide the alert after 5 seconds
        setTimeout(() => {
            setShowAlert(false);
        }, 5000);
    };

    // Function to hide the alert
    const hideErrorAlert = () => {
        setShowAlert(false);
    };

    useEffect(() => {
        getcourse();
    }, []); // Empty dependency array means this effect runs once after the component mounts


    useEffect(() => {
        // window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        // Calls onFocus when the window first loads
        // onFocus();
        // Specify how to clean up after this effect:
        return () => {
            // window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, []);

    // User has switched away from the tab (AKA tab is hidden)
    const onBlur = () => {
        setIsPlaying(false);
    };


    const getcourse = async () => {
        try {
            const token = localStorage.getItem('token'); // Assuming you store the token in localStorage
            const userId = localStorage.getItem('userId'); // Assuming you store the userId in localStorage

            const response = await fetch('https://beiguru.co.in/employee/courses', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token || ''
                },
                body: JSON.stringify({
                    "employeeID": userId || '',
                    "courseID": course.id
                })
            });

            if (!response.ok) {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                }
            }

            const data = await response.json();
            const newCourses = data.video.map(item => {
                const finalItem = CourseContent.fromJson(item);

                if (finalItem.isVideo || finalItem.content.length > 0) {
                    return finalItem;
                }
                return null;
            }).filter(item => item !== null);

            if (course.showConsentForm) {
                newCourses.push(
                    new CourseContent({
                        courseID: "6607fe7d8b97a0d0697b7e15",
                        title: "Cybersecurity Awareness Program",
                        description: "consent",
                        thumbnail: "uploads/1711799933169-School Thumbnail.png",
                        content: {},
                        isVideo: false,
                        isRating: false,
                        isConsent: true,
                        id: 'consent'
                    }),
                    new CourseContent({
                        courseID: "6607fe7d8b97a0d0697b7e15",
                        title: "Cybersecurity Awareness Program",
                        description: "Awareness Program.",
                        thumbnail: "uploads/1711799933169-School Thumbnail.png",
                        content: [
                            {
                                "question": "Write a summary about the pdf.",
                                "options": [null, null, null, null],
                                "isMCQ": false,
                                "createdAt": "2024-03-30T12:11:33.268Z",
                            },
                        ],
                        isVideo: false,
                        isRating: true,
                        isConsent: false,
                        id: 'rating',
                    })
                );
            } else {
                newCourses.push(
                    new CourseContent({
                        courseID: "6607fe7d8b97a0d0697b7e15",
                        title: "Cybersecurity Awareness Program",
                        description: "Awareness Program.",
                        thumbnail: "uploads/1711799933169-School Thumbnail.png",
                        content: [],
                        isVideo: false,
                        isRating: true,
                        isConsent: false,
                        id: 'rating',
                    })
                );
            }
            setCourses(newCourses);
            setCurrentProgress(data.existingProgress.currentProgress);
            setProgressID(data.existingProgress._id);
            setIsFinal(data.existingProgress.isFinal);

            if (data.existingProgress.isConsent) {
                if (data.existingProgress.isConsent == true) {
                    setCurrentIndex(data.existingProgress.currentProgress.length + 1);
                } else {
                    setCurrentIndex(data.existingProgress.currentProgress.length);
                }
            } else {
                setCurrentIndex(data.existingProgress.currentProgress.length);
            }
            console.log(data.existingProgress.currentProgress);
            if (!data.existingProgress.isFinal) {
                getIntoNextModule(newCourses, data.existingProgress.currentProgress.length);
            }
        } catch (error) {
            console.error(error);
        }
    };

    async function getIntoNextModule(courses, cI) {
        let nextUnlockPossible = true;
        try {
            // if (controller) {
            //     controller.dispose();
            // }

            var content = courses[cI].content;

            if (courses[cI].isVideo) {
                if (content.isVideo) {

                    setVideoURL(`${content.video}`);
                    setVideoModule(content);
                    setIsRating(false);
                    setIsConsent(false);
                    setIsContentVideo(true);
                    setIsVideo(true);
                } else {
                    // Set state for non-video content
                    setVideoModule(content);
                    setIsRating(false);
                    setIsConsent(false);
                    setIsContentVideo(false);
                    setIsVideo(true);
                }
            } else {
                // Set state for non-video courses
                if (courses[cI].isRating) {
                    setVideoModule(content);
                    setIsRating(true);
                    setIsConsent(false);
                    setIsContentVideo(false);
                    setIsVideo(false);
                } else if (courses[cI].isConsent) {
                    setVideoModule(content);
                    setIsConsent(true);
                    setIsRating(false);
                    setIsContentVideo(false);
                    setIsVideo(false);
                } else {
                    setCurrentIndex(cI); // Assuming setCurrentIndex updates state
                    setVideoModule(content);
                    setIsRating(false);
                    setIsConsent(false);
                    setIsContentVideo(false);
                    setIsVideo(false);
                    setQuizImage(require('../assets/quiz_image.jpg')); // Assuming setQuizImage updates state
                }
            }
        } catch (error) {
            console.error('Error in getIntoNextModule:', error);
        }
    }

    const filterContentByType = (modules, type) => {
        let items = [];
        modules.forEach(module => {
            module.videosWithQuizzes.forEach(item => {
                switch (type) {
                    case 'content':
                        items.push(item);
                        break;
                    case 'videos':
                        if (item.video.isVideo) {
                            items.push(item);
                        }
                        break;
                    case 'documents':
                        if (!item.video.isVideo) {
                            items.push(item);
                        }
                        break;
                    case 'quiz':
                        if (item.quiz.length > 0) {
                            items.push(item);
                        }
                        break;
                }
            });
        });
        return items;
    };

    const renderContent = (items) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {items.map((item, index) => (
                <Card
                    key={index}
                    elevation={0}
                    sx={{
                        border: '1px solid',
                        borderColor: 'grey.200',
                        borderRadius: 2,
                        overflow: 'hidden'
                    }}
                >
                    <ListItem
                        onClick={() => onCourseDetailClick({
                            ...course,
                            initialContent: item, // Pass the selected content
                            initialModuleIndex: course.modules.findIndex(module =>
                                module.videosWithQuizzes.some(content => content._id === item._id)
                            )
                        })}
                        sx={{
                            py: 2.5,
                            px: 3,
                            '&:hover': {
                                bgcolor: 'grey.50'
                            }
                        }}
                    >
                        <ListItemIcon>
                            {item.video.isVideo ? (
                                <Video className="text-blue-600" size={20} />
                            ) : (
                                <FileText className="text-red-500" size={20} />
                            )}
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    {item.video.title}
                                </Typography>
                            }
                            secondary={
                                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                                    {item.video.description}
                                </Typography>
                            }
                        />
                    </ListItem>
                </Card>
            ))}
        </Box>
    );

    const renderQuizzes = (items) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {items.map((item, index) => (
                <Card
                    key={index}
                    elevation={0}
                    sx={{
                        border: '1px solid',
                        borderColor: 'grey.200',
                        borderRadius: 2,
                        overflow: 'hidden'
                    }}
                >
                    <ListItem
                        sx={{
                            py: 2.5,
                            px: 3,
                            '&:hover': {
                                bgcolor: 'grey.50'
                            }
                        }}
                    >
                        <ListItemIcon>
                            <QuizIcon className="text-purple-600" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    Quiz: {item.video.title}
                                </Typography>
                            }
                            secondary={
                                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                                    {item.quiz.length} questions
                                </Typography>
                            }
                        />
                    </ListItem>
                </Card>
            ))}
        </Box>
    );

    return (
        <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        onClick={onBack}
                        sx={{
                            mr: 2,
                            color: 'text.primary',
                            '&:hover': { bgcolor: 'grey.100' }
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            color: 'text.primary',
                            fontFamily: 'Noto Sans'
                        }}
                    >
                        {course.title}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div style={{ height: '20px', width: '10px' }} />
            <Container maxWidth="lg" sx={{ py: 4, px: { xs: 2, sm: 4 } }}>
                <Grid container spacing={4}>
                    {/* Main Content */}
                    <Grid item xs={12} md={8}>
                        <Card
                            elevation={0}
                            sx={{
                                mb: 4,
                                bgcolor: 'white',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'grey.100'
                            }}
                        >
                            <Grid container spacing={3} sx={{ p: 4 }}>
                                <Grid item xs={12} sm={4}>
                                    <CardMedia
                                        component="img"
                                        image={course.thumbnail}
                                        alt={course.title}
                                        sx={{
                                            borderRadius: 2,
                                            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: 'text.primary', mb: 2 }}>
                                            {course.title}
                                        </Typography>
                                        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
                                            <Chip
                                                label={course.isCompleted ? 'Completed' : 'In Progress'}
                                                color={course.isCompleted ? 'success' : 'primary'}
                                                size="small"
                                                sx={{
                                                    borderRadius: '6px',
                                                    fontWeight: 500
                                                }}
                                            />
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                {course.description}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ mb: 4, width: '100%' }}>
                                            <LinearProgress
                                                variant="determinate"
                                                value={progress}
                                                sx={{
                                                    height: 8,
                                                    borderRadius: 4,
                                                    bgcolor: 'grey.100',
                                                    '& .MuiLinearProgress-bar': {
                                                        borderRadius: 4,
                                                        bgcolor: course.isCompleted ? 'success.main' : 'primary.main'
                                                    }
                                                }}
                                            />
                                        </Box>
                                        <Button
                                            variant="contained"
                                            size="large"
                                            onClick={(event) => {
                                                event.preventDefault();
                                                onCourseDetailClick(course);
                                            }}
                                            startIcon={<PlayArrow />}
                                            sx={{
                                                alignSelf: 'flex-start',
                                                textTransform: 'none',
                                                px: 4,
                                                py: 1.5,
                                                borderRadius: 2,
                                                fontWeight: 500,
                                                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                                            }}
                                        >
                                            {course.isCompleted ? 'Review Course' : 'Start Learning'}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Card>

                        <Box sx={{ mb: 4, borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                                value={activeTab}
                                onChange={(_, newValue) => setActiveTab(newValue)}
                                sx={{
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        minWidth: 120,
                                        fontWeight: 500,
                                        fontSize: '1rem',
                                        py: 2,
                                        color: 'text.secondary',
                                        '&.Mui-selected': {
                                            color: 'primary.main'
                                        }
                                    }
                                }}
                            >
                                <Tab value="content" label="Content" />
                                <Tab value="videos" label="Videos" />
                                <Tab value="documents" label="Documents" />
                                <Tab value="quiz" label="Quiz" />
                            </Tabs>
                        </Box>

                        {activeTab === 'content' && renderContent(filterContentByType(course.modules, 'content'))}
                        {activeTab === 'videos' && renderContent(filterContentByType(course.modules, 'videos'))}
                        {activeTab === 'documents' && renderContent(filterContentByType(course.modules, 'documents'))}
                        {activeTab === 'quiz' && renderQuizzes(filterContentByType(course.modules, 'quiz'))}

                    </Grid>

                    {/* Sidebar */}
                    <Grid item xs={12} md={4}>
                        <Card
                            elevation={0}
                            sx={{
                                border: '1px solid',
                                borderColor: 'grey.200',
                                borderRadius: 2,
                                bgcolor: 'white'
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    sx={{
                                        fontWeight: 600,
                                        color: 'text.primary',
                                        mb: 3
                                    }}
                                >
                                    Course Information
                                </Typography>
                                <List>
                                    <ListItem sx={{ px: 0, py: 1.5 }}>
                                        <ListItemText
                                            primary={`Total Modules: ${course.modules.length}`}
                                            primaryTypographyProps={{
                                                variant: 'body2',
                                                color: 'text.primary'
                                            }}
                                        />
                                    </ListItem>
                                    <ListItem sx={{ px: 0, py: 1.5 }}>
                                        <ListItemText
                                            primary={`Total Content: ${course.modules.reduce(
                                                (acc, module) => acc + module.videosWithQuizzes.length,
                                                0
                                            )}`}
                                            primaryTypographyProps={{
                                                variant: 'body2',
                                                color: 'text.primary'
                                            }}
                                        />
                                    </ListItem>
                                    <ListItem sx={{ px: 0, py: 1.5 }}>
                                        <ListItemText
                                            primary={`Total Quizzes: ${course.modules.reduce(
                                                (acc, module) => acc + module.videosWithQuizzes.reduce(
                                                    (qacc, item) => qacc + item.quiz.length,
                                                    0
                                                ),
                                                0
                                            )}`}
                                            primaryTypographyProps={{
                                                variant: 'body2',
                                                color: 'text.primary'
                                            }}
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

function CourseItem({ course, onClick, active, isChecked, current, disabled }) {
    let icon;
    let title;
    let description;

    if (course.isRating) {
        icon = <StarHalfRounded style={{ color: current ? 'black' : 'silver' }} />;
        title = 'Rating and Review';
        description = 'Provide a quick feedback, and grab your completion certificate';
    } else if (course.isVideo) {
        icon = <PlayArrowRounded style={{ color: current ? 'white' : 'silver' }} />;
        title = course.content.title;
        description = course.content.description;
    } else if (course.isConsent) {
        icon = <WarningAmberRounded style={{ color: current ? 'white' : 'silver' }} />;
        title = 'Consent';
        description = 'Agree to consent.';
    } else {
        icon = <GamepadRounded style={{ color: current ? 'white' : 'silver' }} />;
        title = 'Quiz';
        description = `${course.content.length} modules`;
    }

    return (
        <div disabled={disabled} style={{ opacity: active ? 1 : 0.5 }} onClick={onClick}>
            <div style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
                <div style={{ boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.2)', padding: '5px', borderRadius: '50%', background: current ? 'black' : 'gray' }}>
                    {icon}
                </div>
                <div style={{ marginLeft: '10px', flex: '1' }}>
                    <div style={{ fontSize: '16px', color: 'black', fontWeight: 'bold', fontFamily: 'Noto Sans', }}>{title}</div>
                    <div style={{ fontSize: '14px', color: 'black', fontFamily: 'Noto Sans', }}>{description}</div>
                </div>
                {isChecked ? (
                    <img src={require("../assets/check.png")} alt="Checked" style={{ height: '20px', width: '20px' }} />
                ) : (
                    <img
                        src={require("../assets/round.png")}
                        alt="Unchecked"
                        style={{ height: '20px', width: '20px', filter: 'brightness(0) invert(1)' }}
                    />
                )}
            </div>
        </div>
    );
}

export default UserCourseListScreen;
